import { render, staticRenderFns } from "./RoutesList.vue?vue&type=template&id=7348c029&scoped=true"
import script from "./RoutesList.vue?vue&type=script&lang=js"
export * from "./RoutesList.vue?vue&type=script&lang=js"
import style0 from "./RoutesList.vue?vue&type=style&index=0&id=7348c029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7348c029",
  null
  
)

export default component.exports